import { Box } from '@material-ui/core'
import { FC } from 'react'
import { Button, Modal, Typography } from 'src/modules/core/components'
import classes from './cant-remove-custom-offset-modal.module.scss'

export interface CantRemoveCustomOffsetModalProps {
  onClose: () => void
}

export const CantRemoveCustomOffsetModal: FC<CantRemoveCustomOffsetModalProps> = ({ onClose }) => {
  return (
    <Modal
      variant="primary"
      onClose={onClose}
      isCentered
      title={
        <Typography variant="h3" className={classes.modalTitle}>
          {`You Can't Remove This Timing`}
        </Typography>
      }
    >
      <Box marginBottom={3}>
        <Typography variant="body" className={classes.message}>
          This is the only active timing in one or more Message Templates. Please review your templates and try again.
        </Typography>
      </Box>

      <Box display="flex" justifyContent="center">
        <Button onClick={onClose}>OK</Button>
      </Box>
    </Modal>
  )
}
